// extracted by mini-css-extract-plugin
export default {"Nav":"style_Nav__TQ7+L","adminDetail":"style_adminDetail__CqR2B","icon1":"style_icon1__JD0oq","icon2":"style_icon2__UJ36k","email":"style_email__33Htt","name":"style_name__7tSrP"};